// Autoplay only visible Shopify videos; keep playback controls available on demand.
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = (gallery) => {
    if (gallery.dataset.daridoVideoReady) return;
    gallery.dataset.daridoVideoReady = 'true';
    const visible = new Set();
    const watched = new WeakSet();
    let scheduled = false;

    const configure = (video) => {
      if (video.dataset.daridoAutoplay) return;
      video.dataset.daridoAutoplay = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.autoplay = !reducedMotion.matches;
      video.controls = reducedMotion.matches;
      video.setAttribute('tabindex', '0');
      video.setAttribute('aria-label', 'Product video. Activate to show playback and sound controls.');
      const reveal = () => {
        video.controls = true;
        video.dataset.customerControls = 'true';
        video.setAttribute('aria-label', 'Product video');
      };
      video.addEventListener('click', reveal);
      // Dawn pauses media again when its scrolling animation settles.
      video.addEventListener('pause', () => {
        if (!video.ended && !video.dataset.customerControls) schedule();
      });
      video.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          if (!video.controls) { event.preventDefault(); reveal(); }
        }
      });
    };

    const sync = () => {
      scheduled = false;
      gallery.querySelectorAll('deferred-media').forEach((media) => {
        const source = media.querySelector('template')?.content.querySelector('video');
        if (!source) return;
        source.muted = source.defaultMuted = true;
        source.setAttribute('muted', '');
        source.setAttribute('playsinline', '');
        source.toggleAttribute('autoplay', !reducedMotion.matches);
        source.toggleAttribute('controls', reducedMotion.matches);
        if (!watched.has(media)) { watched.add(media); observer.observe(media); }
        const onScreen = visible.has(media) && !document.hidden && media.getClientRects().length > 0;
        if (onScreen && !reducedMotion.matches && !media.hasAttribute('loaded')) {
          // Use the theme's loader so poster and gallery state stay in sync.
          media.loadContent?.(false);
        }
        const video = media.querySelector('video');
        if (!video) return;
        configure(video);
        if (!onScreen) { video.pause(); return; }
        if (!reducedMotion.matches && !video.dataset.customerControls && video.paused) {
          video.play().catch(() => {
            // Low-power/data-saving browser policies can reject muted autoplay.
            video.controls = true;
          });
        }
      });
    };
    const schedule = () => {
      if (!scheduled) { scheduled = true; requestAnimationFrame(sync); }
    };
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    viewer?.addEventListener('slideChanged', (event) => {
      const activeSlide = event.detail?.currentElement;
      if (!activeSlide || !window.matchMedia('(max-width: 749px)').matches) return;
      // Dawn hides mobile video players until their slide has is-active.
      // Thumbnail clicks set it, but native horizontal swipes do not.
      viewer.querySelectorAll('.product__media-item').forEach((slide) => {
        slide.classList.toggle('is-active', slide === activeSlide);
      });
      schedule();
    });
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting, intersectionRatio }) => {
        if (isIntersecting && intersectionRatio >= 0.35) visible.add(target);
        else visible.delete(target);
      });
      schedule();
    }, { threshold: [0, 0.35] });
    new MutationObserver(schedule).observe(gallery, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'loaded']
    });
    document.addEventListener('visibilitychange', schedule);
    reducedMotion.addEventListener('change', schedule);
    sync();
  };
  document.querySelectorAll('media-gallery').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('media-gallery').forEach(init);
  });
})();
